module.exports = "li.recentTasks {\n    display: inline;\n    list-style-type: none;\n    padding-right: 1rem;\n}"